import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchParticipants = async () => {
  const { data } = await api.get("/participants");
  return data;
};

export const fetchSummary = async () => {
  const { data } = await api.get("/fundraising/summary");
  return data;
};

export const fetchChampions = async () => {
  const { data } = await api.get("/champions");
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await api.post("/sponsor-inquiry", payload);
  return data;
};
